import React from "react";

export const Logo = ({ className = "", onClick }) => (
  <button
    onClick={onClick}
    data-testid="logo-wordmark"
    className={`group flex items-center gap-2 font-head font-black tracking-tight leading-none select-none ${className}`}
  >
    <span className="flex items-center gap-1 text-orange">
      <span className="hidden sm:flex flex-col gap-[3px]">
        <span className="block h-[3px] w-4 bg-orange rotate-[-8deg]" />
        <span className="block h-[3px] w-5 bg-orange rotate-[-8deg]" />
        <span className="block h-[3px] w-3 bg-orange rotate-[-8deg]" />
      </span>
    </span>
    <span className="text-white text-2xl md:text-[1.7rem]">
      AUS<span className="text-orange">/</span>SIGNS
    </span>
    <span className="text-orange text-2xl md:text-[1.7rem] -ml-1 group-hover:translate-x-1 transition-transform">»</span>
  </button>
);
